import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})

export class GlobalService {

	urlApiParam: string;

	constructor() { 
		if(document.body.dataset.url) {
			this.urlApiParam = document.body.dataset.url;
		} else {
			this.urlApiParam = environment.api_base_url;
		}
	}
}
